<template>
  <div>
    <div class="flex flex-wrap">
      <div class="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
      
      
        <card-line-chart />
      </div>
      <div class="w-full xl:w-4/12 px-4">
        <card-bar-chart />
      </div>
    </div>
    <div class="flex flex-wrap mt-4">
      <div class="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
        <card-page-visits />
      </div>
      <div class="w-full xl:w-4/12 px-4">
        <card-social-traffic />
      </div>
    </div>
  </div>
</template>
<script>
import CardLineChart from "@/components/Cards/CardLineChart.vue";
import CardBarChart from "@/components/Cards/CardBarChart.vue";
import CardPageVisits from "@/components/Cards/CardPageVisits.vue";
import CardSocialTraffic from "@/components/Cards/CardSocialTraffic.vue";
export default {
  name: "dashboard-page",
  components: {
    CardLineChart,
    CardBarChart,
    CardPageVisits,
    CardSocialTraffic,
  },
 data(){
   return {
     message : 'Subs 1  : <br>'
   }
 },
 methods : {
    // publish1 () {
    //   this.$mqtt.publish('VueMqtt/publish1', 'message to Sub1')
    // },
    publish2 () {
      this.$mqtt.publish('tekkoma/led', 'message to Sub2');
    }
 },
 mqtt : {
    /** 'VueMqtt/publish2' or '+/publish2' */
    '+/publish2' (data) {
        // this.buff = this.buff + data + '<br>'
        console.log(data);
    },
   'tekkoma/+' (data, topic){
     if(topic.split('/').pop() === 'led'){
       console.log('topic : ', 'tekkoma/led : ');
       console.log(data.toString());
     }
   },
  
 }
};
</script>
